import type { ReactNode } from 'react';
import React from 'react';

import * as styles from '../styles/DrawerContent.styles';

export interface DrawerContentProps {
  children: ReactNode;
}

export const DrawerContent = ({ children }: DrawerContentProps) => (
  <div css={styles.scrollableContent}>{children}</div>
);
